/* eslint-disable react/jsx-no-useless-fragment */
import { memo } from 'react';
import useAuthentication from 'base/auth/hooks/use-authentication';
import { useLocation, Navigate } from 'react-router-dom';

interface Props {
  children: any;
}

const AuthWrapper = memo(({ children }: Props) => {
  const { isAuthenticated } = useAuthentication();
  const location = useLocation();

  if (location.pathname.includes('not-found')) return null;

  const authenticated = isAuthenticated();

  return authenticated ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ path: location.pathname }} />
  );
});

export default AuthWrapper;
